export default "__VITE_ASSET__45f0cd3f__"